var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup160(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(-1208 -3175)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 67,
    height: 67,
    rx: 15,
    transform: "translate(1208 3175)",
    fill: "#f6f6fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "operational-system",
    transform: "translate(1219.491 3184.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(2.423 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M19.337,12.374a7.31,7.31,0,0,0-.321-2.143l1.922-1.239L18.768,5.611,16.84,6.85a7.54,7.54,0,0,0-2.859-1.56V3H9.963V5.29A7.362,7.362,0,0,0,7.1,6.85L5.176,5.611,3,8.992l1.922,1.239a7.537,7.537,0,0,0-.315,2.143,7.31,7.31,0,0,0,.321,2.143L3,15.755l2.176,3.381L7.1,17.9a7.362,7.362,0,0,0,2.859,1.56v2.29h4.017v-2.29A7.362,7.362,0,0,0,16.84,17.9l1.928,1.239,2.176-3.381-1.922-1.239a7.537,7.537,0,0,0,.315-2.143Zm-7.365,4.017a4.017,4.017,0,1,1,4.017-4.017A4.02,4.02,0,0,1,11.972,16.391Z",
    transform: "translate(-3 -3)",
    fill: "#8aba55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(22.229 21.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M52.537,44.374a7.31,7.31,0,0,0-.321-2.143l1.928-1.239-2.176-3.381L50.04,38.85a7.362,7.362,0,0,0-2.859-1.56V35H43.163v2.29A7.362,7.362,0,0,0,40.3,38.85l-1.928-1.239L36.2,40.992l1.922,1.239a7.3,7.3,0,0,0,0,4.285L36.2,47.755l2.176,3.381L40.3,49.9a7.362,7.362,0,0,0,2.859,1.56v2.29h4.017v-2.29A7.362,7.362,0,0,0,50.04,49.9l1.928,1.239,2.176-3.381-1.922-1.239a7.537,7.537,0,0,0,.315-2.143Zm-7.365,4.017a4.017,4.017,0,1,1,4.017-4.017A4.02,4.02,0,0,1,45.172,48.391Z",
    transform: "translate(-36.2 -35)",
    fill: "#7cb5e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(7.365 7.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M16.692,28.924a10.186,10.186,0,0,0,1.379,3.334l-1.62,2.189,2.544,2.544,2.189-1.62a10.186,10.186,0,0,0,3.334,1.379l.4,2.692h3.6l.4-2.692a10.186,10.186,0,0,0,3.334-1.379l2.189,1.62,2.544-2.544-1.62-2.189a10.186,10.186,0,0,0,1.379-3.334l2.692-.4v-3.6l-2.692-.4a10.186,10.186,0,0,0-1.379-3.334L36.986,19l-2.544-2.544-2.189,1.62A10.186,10.186,0,0,0,28.918,16.7l-.4-2.7h-3.6l-.4,2.692a10.186,10.186,0,0,0-3.334,1.379L19,16.451l-2.544,2.544,1.62,2.189A10.186,10.186,0,0,0,16.7,24.519l-2.7.4v3.6Zm5.176-2.2a4.854,4.854,0,1,1,4.854,4.854A4.853,4.853,0,0,1,21.867,26.721Z",
    transform: "translate(-14 -14)",
    fill: "#ffab03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(13.94 7.365)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M38.617,21.184l1.62-2.189-2.544-2.544L35.5,18.071a10.186,10.186,0,0,0-3.334-1.379L31.768,14h-3.6l-.4,2.692a10.186,10.186,0,0,0-3.334,1.379l-.4-.288a11.8,11.8,0,0,0-.221,2.243,11.6,11.6,0,0,0,1.426,5.591,4.854,4.854,0,1,1,6.716,5.53,11.578,11.578,0,0,0,3.529.542,11.77,11.77,0,0,0,3.783-.636A10.048,10.048,0,0,0,40,28.918l2.692-.4v-3.6L40,24.519a10.346,10.346,0,0,0-1.386-3.334Z",
    transform: "translate(-23.82 -14)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(1.252 3.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M53.863,21.806a.505.505,0,0,0-.71,0l-1.165,1.165A19.266,19.266,0,0,0,32.752,4.25a.5.5,0,0,0,0,1A18.263,18.263,0,0,1,50.984,22.944l-1.138-1.138a.5.5,0,1,0-.71.71l2.009,2.009a.5.5,0,0,0,.71,0l2.009-2.009a.505.505,0,0,0,0-.71Z",
    transform: "translate(-11.496 -4.25)",
    fill: "#4e6575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M22.509,50.668A18.263,18.263,0,0,1,4.277,32.978l1.138,1.138a.5.5,0,0,0,.71,0,.505.505,0,0,0,0-.71L4.116,31.4a.505.505,0,0,0-.71,0L1.4,33.407a.5.5,0,1,0,.71.71l1.165-1.165A19.266,19.266,0,0,0,22.509,51.672a.5.5,0,1,0,0-1Z",
    transform: "translate(-1.252 -13.173)",
    fill: "#4e6575"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup160);
export default __webpack_public_path__ + "static/media/Group 160.f9188700e7454677f79f9f9a754d7036.svg";
export { ForwardRef as ReactComponent };